import { render } from "./QwImg.vue?vue&type=template&id=54d7ea9d"
import script from "./QwImg.vue?vue&type=script&lang=js"
export * from "./QwImg.vue?vue&type=script&lang=js"

import "./QwImg.vue?vue&type=style&index=0&id=54d7ea9d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__